<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">New Purchase Invoice</h4>
                    <p class="text-subtitle-1">Purchase Invoice Creation Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseInvoiceForm 
                        ref="form"
                        v-model="data"
                        v-if="!orderLoading"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block class="primary" @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert" />
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex'
import PAlert from './../../components/common/PAlert'
import PurchaseInvoiceForm from "./../../components/purchase/PurchaseInvoiceForm.vue";
import { v4 as uuid } from 'uuid';

export default {
    name: "PurchaseInvoiceCreateView",
    components: {
        PurchaseInvoiceForm,
        PAlert
    },
    data() {
        return{
            alert: {
                value: false,
                title: "Alert",
                content: "are you sure",
                callback: null
            },
            loading: false,
            dataLoading: false,
            data: null,
            perm: permissions,
            idempotentKey: null,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "purchase/invoice/create",
            findOrderByID: "purchase/order/findByID",
            snackbar: "ui/snackbar/show",
            pushItem: "purchase/item/push",
            pushSupplier: "purchase/supplier/push"
        }),
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save}
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleList() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to leave this page", callback: this.navigateToList }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.push({ name: "PurchaseInvoiceDisplay", params: { id: response.data.id }})
                this.snackbar({text: 'Purchase Invoice Create', color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error; 
                this.snackbar({ text: message, color: "error"});
            }).finally(() => {
                this.loading = false
            })
        },
        navigateToList() {
            this.$router.push({name: "PurchaseInvoiceList"})
        },
        mapOrderToInvoice(order) {
            this.pushSupplier(order.supplier);
            return {
                ...order,
                due_date: order.date,
                supplier_id: order.supplier.id,
                purchase_order_id: order.id,
                purchase_order_code: order.code,
                base_amount: 0,
                amount: 0,
                exchange_rate: order.exchange_rate,
                lines: order.lines.map(line => {
                    this.pushItem(line.item);
                    return {
                        ...line,
                        item_id: line.item.id,
                        measure_unit_id: line.measure_unit.id,
                        tax_id: line.tax.id
                    }
                })
            }
        },
        fetchOrder(orderId) {
            this.dataLoading = true;
            this.findOrderByID(orderId).then(response => {
                this.data = this.mapOrderToInvoice(response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error; 
                this.snackbar({ text: message, color: "error"});
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    mounted() {
        if(this.$route.query.order_id) {
            this.fetchOrder(this.$route.query.order_id);
            return;
        }
        this.handleNewLine();
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>